import { inject } from "@angular/core";
import { type Route, Router } from "@angular/router";

import { checkByPlan, NotArchivedPlan } from "../../../core/guards";
import { AdaaHelper } from "../../../core/utils";
import { Constants } from "../../../shared/constants/constants";
import { AdaaBoolean, DataRevisionIds, PageMode } from "../../../shared/constants/enums";
import { submenuGuards } from "../_guard";

const enablerObjectiveRoutes: Route[] = [
  {
    path: "enabler-objective/create",
    canActivate: [NotArchivedPlan()],
    data: {
      title: "breadcrumbs.enablerobjectives.new",
      breadcrumb: "breadcrumbs.enablerobjectives.new",
      pageMode: PageMode.create,
      enabler: AdaaBoolean.Y,
      objectiveType: Constants.OBJECTIVE_TYPE.ENABLER_OBJECTIVE,
    },
    loadComponent: () => import("../objectives-editor/objectives-editor").then((m) => m.ObjectivesEditorComponent),
  },
  {
    path: "enabler-objective/edit/:id",
    canActivate: [NotArchivedPlan()],
    data: {
      title: "breadcrumbs.enablerobjectives.edit",
      breadcrumb: "breadcrumbs.enablerobjectives.edit",
      pageMode: PageMode.edit,
      enabler: AdaaBoolean.Y,
      objectiveType: Constants.OBJECTIVE_TYPE.ENABLER_OBJECTIVE,
    },
    loadComponent: () => import("../objectives-editor/objectives-editor").then((m) => m.ObjectivesEditorComponent),
  },
  {
    path: "enabler-objective/:id",
    canActivate: [],
    data: {
      title: "breadcrumbs.enablerobjectives.view",
      breadcrumb: "breadcrumbs.enablerobjectives.view",
      enabler: AdaaBoolean.Y,
      type: Constants.OBJECTIVE_TYPE.ENABLER_OBJECTIVE,
    },
    loadComponent: () => import("../objectives-view/objectives-view").then((m) => m.ObjectivesViewComponent),
  },
];

const transformationalObjectiveRoute: Route[] = [
  {
    path: "transformational-objective/create",
    canActivate: [NotArchivedPlan(), checkByPlan([DataRevisionIds.DS1, DataRevisionIds.DS2])],
    data: {
      title: "breadcrumbs.objectives.transformational_create",
      breadcrumb: "breadcrumbs.objectives.transformational_create",
      pageMode: PageMode.create,
      enabler: AdaaBoolean.N,
      objectiveType: Constants.OBJECTIVE_TYPE.TRANSFORMATIONAL_OBJECTIVE,
    },
    loadComponent: () => import("../objectives-editor/objectives-editor").then((m) => m.ObjectivesEditorComponent),
  },
  {
    path: "transformational-objective/edit/:id",
    canActivate: [NotArchivedPlan(), checkByPlan([DataRevisionIds.DS1, DataRevisionIds.DS2])],
    data: {
      title: "breadcrumbs.objectives.transformational_edit",
      breadcrumb: "breadcrumbs.objectives.transformational_edit",
      pageMode: PageMode.edit,
      enabler: AdaaBoolean.N,
      objectiveType: Constants.OBJECTIVE_TYPE.TRANSFORMATIONAL_OBJECTIVE,
    },
    loadComponent: () => import("../objectives-editor/objectives-editor").then((m) => m.ObjectivesEditorComponent),
  },
  {
    path: "transformational-objective/:id",
    canActivate: [checkByPlan([DataRevisionIds.DS1, DataRevisionIds.DS2])],
    data: {
      title: "breadcrumbs.objectives.transformational_view",
      breadcrumb: "breadcrumbs.objectives.transformational_view",
      enabler: AdaaBoolean.N,
      type: Constants.OBJECTIVE_TYPE.TRANSFORMATIONAL_OBJECTIVE,
    },
    loadComponent: () => import("../objectives-view/objectives-view").then((m) => m.ObjectivesViewComponent),
  },
];

/**
 * Pmo can only access view strategic objective
 * Pmo can only access view main objective
 */
const pmoViewEntityObjectiveRoutes: Route[] = [
  {
    path: "main-objective/:id",
    canActivate: [NotArchivedPlan()],
    data: {
      title: "breadcrumbs.objectives.main_view",
      breadcrumb: "breadcrumbs.objectives.main_view",
      enabler: AdaaBoolean.N,
      type: Constants.OBJECTIVE_TYPE.MAIN_OBJECTIVE,
    },
    loadComponent: () => import("../objectives-view/objectives-view").then((m) => m.ObjectivesViewComponent),
  },
  {
    path: "strategic-objective/:id",
    canActivate: [NotArchivedPlan()],
    data: {
      title: "breadcrumbs.objectives.strategic_view",
      breadcrumb: "breadcrumbs.objectives.strategic_view",
      enabler: AdaaBoolean.N,
      type: Constants.OBJECTIVE_TYPE.STRATEGIC_OBJECTIVE,
    },
    loadComponent: () => import("../objectives-view/objectives-view").then((m) => m.ObjectivesViewComponent),
  },
];

export const pmoObjectivesRoutes: Route = {
  path: "pmo-objectives",
  canActivate: [
    () => {
      const router = inject(Router);

      return !AdaaHelper.isPMOEntity() ? router.createUrlTree(["/console/objectives"]) : true;
    },
  ],
  children: [
    {
      path: "",
      canActivate: [...submenuGuards],
      data: {
        title: "breadcrumbs.objectives.objectives",
        breadcrumb: "breadcrumbs.objectives.objectives",
        tableConfList: Constants.MAIN_TABLE_LIST_CONF_KEY.ENABLER_OBJECTIVES,
        enabler: AdaaBoolean.Y,
        itemTypeId: Constants.CONSTANT_PERMISSIONS.OBJECTIVES,
      },
      loadComponent: () => import("../objectives-list/objectives-list").then((m) => m.ObjectivesListComponent),
    },
    ...transformationalObjectiveRoute,
    ...enablerObjectiveRoutes,
    ...pmoViewEntityObjectiveRoutes,
  ],
};
